import { DarkTheme } from "@/enums/theme-choices"

export const dark = {
  [DarkTheme.SYSTEM]: {
    name: "Systeem",
    value: "system",
    description: "Volgt de instellingen van je apparaat"
  },
  [DarkTheme.LIGHT]: {
    name: "Licht",
    value: "light",
    description: "Altijd lichte weergave"
  },
  [DarkTheme.DARK]: {
    name: "Donker",
    value: "dark",
    description: "Altijd donkere weergave"
  }
}
